import GooglePreviewBaseController from "./google_preview_base_controller"
import {
  extractMappedValue,
  fieldDisplayLabel,
  fieldsGroupedByPlatformSlot
} from "../field_mapping_preview_support"
import { buildGooglePreviewState } from "./preview_state_builder"

function buildGoogleMappingPayload(c) {
  return buildGooglePreviewState({
    name: c.nameValue,
    background_colour: c.backgroundColourValue || "#ffffff",
    foreground_colour: c.foregroundColourValue || "#000000",
    label_colour: c.labelColourValue || "#000000",
    logo_android: c.logoAndroidValue || "",
    logo_large: c.logoLargeValue || "",
  })
}

export default class GoogleCardPreviewMappingController extends GooglePreviewBaseController {
  static values = {
    name: String,
    backgroundColour: String,
    foregroundColour: String,
    labelColour: String,
    logoAndroid: String,
    logoLarge: String,
  }

  connect() {
    this.applyGooglePreview(this.mappingPayload())
    this.applyPlacement({}, {})
  }

  disconnect() {
    this.releaseObjectUrls()
  }

  applyPlacement(fields, sample) {
    const byPos = fieldsGroupedByPlatformSlot(fields, "google")
    this.setHeader(byPos.HeaderTop, sample)
    this.setRowStart(byPos.Row1Left, sample)
    this.setRowMid(byPos.Row1Mid, sample)
    this.setRowEnd(byPos.Row1Right, sample)
    this.setQrCodeArea(byPos.code, sample)
  }

  setHeader(entry, sample) {
    if (!this.hasGoogleTitleTarget) return
    if (!entry) {
      this.googleTitleTarget.textContent = ""
      return
    }
    this.googleTitleTarget.textContent = extractMappedValue(sample, entry.def) || ""
  }

  setRowStart(entry, sample) {
    this.setPair(
      this.hasGoogleTextLabelTarget ? this.googleTextLabelTarget : null,
      this.hasGoogleTextValueTarget ? this.googleTextValueTarget : null,
      entry,
      sample
    )
  }

  setRowMid(entry, sample) {
    this.setPair(
      this.hasGoogleMidLabelTarget ? this.googleMidLabelTarget : null,
      this.hasGoogleMidValueTarget ? this.googleMidValueTarget : null,
      entry,
      sample
    )
  }

  setRowEnd(entry, sample) {
    this.setPair(
      this.hasGoogleStatusLabelTarget ? this.googleStatusLabelTarget : null,
      this.hasGoogleStatusValueTarget ? this.googleStatusValueTarget : null,
      entry,
      sample
    )
  }

  setQrCodeArea(entry, sample) {
    this.toggleGoogleQrBlocks(!!entry)
    this.setGoogleMemberLine(entry, sample)
  }

  toggleGoogleQrBlocks(show) {
    if (this.hasGoogleQrTarget) this.googleQrTarget.classList.toggle("d-none", !show)
    if (this.hasGoogleMemberTarget) this.googleMemberTarget.classList.toggle("d-none", !show)
  }

  setGoogleMemberLine(entry, sample) {
    if (!this.hasGoogleMemberTextTarget) return
    if (!entry) {
      this.googleMemberTextTarget.textContent = ""
      return
    }
    const lbl = fieldDisplayLabel(entry.key, entry.def)
    const val = extractMappedValue(sample, entry.def) || ""
    this.googleMemberTextTarget.textContent = val ? `${lbl}: ${val}` : lbl
  }

  setPair(labelEl, valueEl, entry, sample) {
    if (!labelEl && !valueEl) return
    if (!entry) return this.fillPair(labelEl, valueEl, "", "")
    const lbl = fieldDisplayLabel(entry.key, entry.def)
    const val = extractMappedValue(sample, entry.def) || ""
    this.fillPair(labelEl, valueEl, lbl, val)
  }

  fillPair(labelEl, valueEl, lbl, val) {
    if (labelEl) labelEl.textContent = lbl
    if (valueEl) valueEl.textContent = val
  }

  mappingPayload() {
    return buildGoogleMappingPayload(this)
  }
}
